import { useRef } from "react";

/** Ignores a second call until the first promise settles. Stops double-taps from creating two POs. */
export function useSingleFlight() {
  const held = useRef(false);
  return async function run<T>(fn: () => Promise<T>): Promise<T | undefined> {
    if (held.current) return undefined;
    held.current = true;
    try {
      return await fn();
    } finally {
      held.current = false;
    }
  };
}
